/**
 * Google Analytics (GA4) Utility
 * Provides functions for tracking events, page views, and conversions
 */

// Track page views
export const trackPageView = (path, title) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title || document.title
    });
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, eventParams);
  }
};

// Track user signup
export const trackSignup = (method) => {
  trackEvent('sign_up', {
    method: method // 'email', 'google', etc.
  });
};

// Track user login
export const trackLogin = (method) => {
  trackEvent('login', {
    method: method
  });
};

// Track appointment booking
export const trackAppointmentBooking = (appointmentData) => {
  trackEvent('appointment_booked', {
    provider_id: appointmentData.doctor_id,
    service_name: appointmentData.service_name,
    consultation_fee: appointmentData.consultation_fee,
    payment_method: appointmentData.payment_method,
    currency: 'KWD'
  });
  
  // Also track as a conversion
  trackEvent('purchase', {
    transaction_id: appointmentData.id,
    value: appointmentData.consultation_fee,
    currency: 'KWD',
    items: [{
      item_id: appointmentData.service_id,
      item_name: appointmentData.service_name,
      price: appointmentData.consultation_fee,
      quantity: 1
    }]
  });
};

// Track wallet top-up
export const trackWalletTopUp = (amount) => {
  trackEvent('wallet_top_up', {
    value: amount,
    currency: 'KWD'
  });
};

// Track search
export const trackSearch = (searchTerm, searchType) => {
  trackEvent('search', {
    search_term: searchTerm,
    search_type: searchType // 'provider', 'service', etc.
  });
};

// Track provider profile view
export const trackProviderView = (providerId, providerName) => {
  trackEvent('view_item', {
    item_id: providerId,
    item_name: providerName,
    item_category: 'provider'
  });
};

// Track service selection
export const trackServiceSelection = (serviceId, serviceName, price) => {
  trackEvent('select_item', {
    item_id: serviceId,
    item_name: serviceName,
    price: price,
    currency: 'KWD'
  });
};

// Track button clicks
export const trackButtonClick = (buttonName, location) => {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location // 'homepage', 'profile', etc.
  });
};

// Track errors
export const trackError = (errorMessage, errorLocation) => {
  trackEvent('error', {
    error_message: errorMessage,
    error_location: errorLocation
  });
};

// Set user properties (for logged-in users)
export const setUserProperties = (userId, userType) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', 'G-9LZYHJVLMP', {
      'user_id': userId,
      'user_properties': {
        'user_type': userType // 'patient', 'provider', 'admin'
      }
    });
  }
};

export default {
  trackPageView,
  trackEvent,
  trackSignup,
  trackLogin,
  trackAppointmentBooking,
  trackWalletTopUp,
  trackSearch,
  trackProviderView,
  trackServiceSelection,
  trackButtonClick,
  trackError,
  setUserProperties
};
